import Instance from '../../../Axios';

// New Actions for the app

const GetApartamentoReservas = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .get(`/backend/reservas/datas/${id}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_APARTAMENTO_RESERVAS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetApartamentoReservas;
